import axios from 'axios';
import i18n from '../i18n';
import router from '../chats/routes';
import env from '../env';
import Vue from 'vue';
import chat from '../chats/store/modules/chats';
import Locale from '../vue-i18n-locales.generated';

axios.defaults.xsrfCookieName = 'csrftoken';
axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";

let $t = (item) =>
  localStorage.getItem('language')
    ? Locale[localStorage.getItem('language')][item]
    : Locale['ua'][item];

const state = {
  users: [],
  teachers: [],
  students: [],
  dashboard: {
    data: [],
  },
  loggedIn: false,
  loggedInHash: null,
  userData: null,
  ckeditorModal: {
    config: null,
    isActive: false,
    value: '',
    request: {
      method: null,
      url: null,
    },
    loggedIn: false,
    loggedInHash: null,
    userData: null,
    ckeditorModal: {
      config: null,
      isActive: false,
      value: '',
      request: {
        method: null,
        url: null,
      },
      question: null,
      id: null,
    },
  },
  showPreloader: false,
  questionModalContent: "", 
  manifest: null,
  achievementTasks: {
    weekly: null,
    daily: null
  },
};

const mutations = {
  SET_CKEDITOR_MODAL_DATA(
    state,
    {
      isActive = false,
      config = null,
      method = null,
      url = null,
      value = '',
      question = null,
      id = null,
    }
  ) {
    state.ckeditorModal.config = config;
    state.ckeditorModal.isActive = isActive;
    state.ckeditorModal.value = value;
    state.ckeditorModal.request.method = method;
    state.ckeditorModal.request.url = url;
    state.ckeditorModal.question = question;
    state.ckeditorModal.id = id;
  },
  SET_STATE(state, data) {
    state[data.prop] = data.value;
  },
  SET_USERS(state, users) {
    state.users = users;
  },
  SET_QUESTION_MODAL_CONTENT(state, questionModalContent) {
    state.questionModalContent = questionModalContent;
  },  
  SET_DASHBOARD_DATA(state, data) {
    state.dashboard.data = data;
  },
  SET_LOGGED_IN(state, loggedIn) {
    state.loggedIn = loggedIn;
    state.loggedInHash = Math.random();
  },
  SET_USERDATA(state, userData) {
    state.userData = userData;
  },
  SET_USER_PHOTO(state, photo) {
    state.userData.photo = photo;
  },
  SET_SHOW_PRELOADER(state, show) {
    state.showPreloader = show;
  },
  SET_MANIFEST(state, manifest) {
    state.manifest = manifest;
  },
  SET_ACHIEVEMENT_TASKS(state, { content, period }) {
    state.achievementTasks[period] = content;
  },
};

const actions = {
  user: ({ commit }, form_data) => {
    return new Promise((resolve, reject) => {
      axios
        .put(env.api_url + 'user/' + state.userData.id + '/', form_data, {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            Accept: 'application/json',
            Authorization: 'Bearer ' + localStorage.getItem('token'),
          },
        })
        .then(
          (res) => {
            if (res && typeof res.data.success !== 'undefined') {
              commit('SET_USERDATA', res.data.data);
              res.data.msg = $t('success_saved');
            }
            resolve(res);
          },
          (err) => {
            console.log(err, 'err in vuex');
            reject({ err, msg: err.response.data.error_description[0] });
          }
        );
    });
  },

  login: ({ commit, dispatch }, params) => {
    return new Promise((resolve, reject) => {
      axios
        .post(
          env.api_url + 'auth/' + params.school_id + '/',
          params.credentials
        )
        .then((response) => {
          if (response && typeof response.data.success !== 'undefined') {
            localStorage.setItem('token', response.data.data.token);
            commit('SET_LOGGED_IN', true);
            if (['billing'].includes(response.data.role)) {
              window.location.href = '/payer';
            }
            dispatch('whoami');
            dispatch('channels');
          }
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  resetPassword: ({ commit }, params) => {
    commit('SET_LOGGED_IN', false);

    return new Promise((resolve, reject) => {
      axios
        .post(env.api_url + 'reset_password/' + params.school_id + '/', params)
        .then(
          (response) => {
            if (response && typeof response.data !== 'undefined') {
              if (
                typeof response.data.success !== 'undefined' &&
                response.data.success
              ) {
                commit('SET_LOGGED_IN', false);
                commit('SET_FOR_COMPONENT', {
                  page: 'resetPassword',
                  field: 'error',
                  value: false,
                });
                resolve(true);
              } else {
                commit('SET_FOR_COMPONENT', {
                  page: 'resetPassword',
                  field: 'error',
                  value: true,
                });
              }
            } else {
              //
            }
          },
          (error) => {
            commit('SET_FOR_COMPONENT', {
              page: 'resetPassword',
              field: 'error',
              value: true,
            });
            console.error(
              'Error! Details in console.log',
              error.response.data.non_field_errors
            );
            reject();
          }
        );
    }).catch((err) => {
      console.log(err, 'err');
    });
  },
  whoami: ({ commit, dispatch }) => {
    return new Promise((resolve, reject) => {
      // console.log( localStorage.getItem('token'))
      axios
        .get(env.api_url + 'whoami/', {
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            Authorization: 'Bearer ' + localStorage.getItem('token'),
          },
          params: {
            lang: localStorage.getItem('language'),
          },
        })
        .then(
          (response) => {
            if (response && typeof response.data.success !== 'undefined') {
              resolve(response);
              commit('SET_LOGGED_IN', true);
              commit('SET_USERDATA', response.data.data);
              if (
                window.location.pathname.indexOf('/chat') !== -1 ||
                window.location.pathname.indexOf('/courses') !== -1
              ) {
                commit(
                  'SET_SCHOOL_STUDENTS_GROUPS',
                  response.data.data.school_students_groups
                );
                commit(
                  'SET_STUDENT_GROUPS',
                  response.data.data.students_groups
                );
                commit(
                    'SET_ELECTIVE_COURSES_CROUPS',
                    response.data.data.elective_courses_groups
                );
              }

              if (window.location.pathname.indexOf('/payer') !== -1) {
                dispatch('GET_PAYER_STUDENTS', response.data.data.students, {
                  root: true,
                });
              }

              if (
                (window.location.pathname === '/courses/' ||
                  window.location.pathname === '/courses/login') &&
                (response.data.data.role !== 'teacher' &&
                  response.data.data.role !== 'moderator' &&
                  response.data.data.role !== 'admin')
              ) {
                // window.location = window.location.origin + '/chat'
              }
              if (
                (window.location.pathname === '/payer/' ||
                  window.location.pathname === '/payer/login' ||
                  window.location.pathname === '/payer') &&
                (response.data.data.role !== 'billing' &&
                  response.data.data.role !== 'student/billing' &&
                  response.data.data.role !== 'moderator' &&
                  response.data.data.role !== 'admin')
              ) {
                window.location = window.location.origin + '/chat';
              }
            } else {
              commit('SET_LOGGED_IN', false);
            }
          },
          (err) => {
            reject(err);
            commit('SET_LOGGED_IN', false);
            console.log(err);
          }
        );
    });
  },
  logout: ({ commit }) => {
    commit('SET_LOGGED_IN', false);
    localStorage.removeItem('token');
  },

  getDashboardData: ({ commit, dispatch, state }) => {
    axios
      .get(env.api_url + 'dashboard/channels_data/', {
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          Authorization: 'Bearer ' + localStorage.getItem('token'),
        },
      })
      .then(
        (res) => {
          if (res && typeof res.data.success !== 'undefined') {
            commit('SET_DASHBOARD_DATA', res.data.data);
          }
        },
        (err) => console.log(err)
      );
  },
  getAllUsers: ({ commit, dispatch }) => {
    let ids = [];
    chat.state.chatsAll.forEach((chat) => ids.push(chat.id));

    axios
      .get(env.api_url + 'dashboard/school_members/', {
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          Authorization: 'Bearer ' + localStorage.getItem('token'),
        },
        params: {
          channel_ids: ids.join(),
        },
      })
      .then(
        (res) => {
          if (res && typeof res.data.success !== 'undefined') {
            let users = res.data.data;
            dispatch('members_online_status', ids.join()).then(
              (data) => {
                users.forEach((user) => {
                  data.forEach((status) => {
                    if (user.id === status.id) {
                      user['is_online'] = status.is_online;
                    }
                  });
                });
              },
              (err) => console.log(err, 'consoling')
            );
            commit('SET_USERS', users);

            let teachers = users.filter(
              (teacher) =>
                teacher.role === 'owner' ||
                teacher.role === 'teacher' ||
                teacher.role === 'admin'
            );
            commit('SET_STATE', { prop: 'teachers', value: teachers });

            let students = users.filter(
              (student) =>
                student.role === 'student' || student.role === 'student/billing'
            );
            commit('SET_STATE', { prop: 'students', value: students });
          }
        },
        (err) => console.log(err)
      );
  },
  ckeditorRequest: ({ commit }, params) => {
    return new Promise((resolve, reject) => {
      axios
        .get(env.api_url + 'dashboard/school_members/', {
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            Authorization: 'Bearer ' + localStorage.getItem('token'),
          },
          params: params,
        })
        .then(
          (res) => {
            resolve(res);

            commit('SET_CKEDITOR_MODAL_DATA', {
              isActive: false,
              config: null,
            });
          },
          (err) => reject(err)
        );
    });
  },
  changeLanguage({ state }, langId) {
    const userId = state.userData.id;
    
    return new Promise((resolve, reject) => {
      axios({
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          Authorization: 'Bearer ' + localStorage.getItem('token'),
        },
        method: 'PATCH',
        url: `${env.api_url}user/${userId}/lang/`,
        params: {
          lang: langId,
        },
      })
        .then((response) => {
          const { success } = response.data;

          if (success) {
            resolve(data);
          }

          reject(new Error());
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getModalContent({ commit, dispatch, state }, slug) {
    commit('SET_QUESTION_MODAL_CONTENT', '');
    return new Promise((resolve, reject) => {
      axios({
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          Authorization: 'Bearer ' + localStorage.getItem('token'),
        },
        method: 'GET',
        url: `${env.api_url}instruction/${slug}`,
        params: {
          lang: localStorage.getItem('language'),
        },
      })
        .then((response) => {
          if (response && typeof response.data.success !== 'undefined') {
            let content = response.data.data.text_ua
            if (typeof response.data.data["text_" + localStorage.getItem('language')] !== 'undefined'){
              content = response.data.data["text_" + localStorage.getItem('language')]
            }
            commit('SET_QUESTION_MODAL_CONTENT', content)
            resolve(response);
          }
        })
        .catch((error) => {
          commit('SET_NOTIFICATION_ALERT', {
              text: $t('instruction_not_found'),
              isActive: true,
            });
          reject(error);
        });
    });
  },

  setShowPreloader({ commit }, isShow) {
    commit('SET_SHOW_PRELOADER', isShow);
  },
  updateManifest: ({ commit, dispatch, state }) => {
    axios
      .get(env.public_base + '/mix-manifest.json', {
        headers: {
          'Content-Type': 'application/json',
        },
      })
      .then(
        (res) => {
          if (res) {
            commit('SET_MANIFEST', res.data);
          }
        },
        (err) => console.log(err)
      );
  },
  async uploadFile({}, {blob, filename}) {
    try {
      const formData = new FormData();
      formData.append('upload', blob, filename);

      const apiUrl = `${env.api_url}ckeditor_image_upload/?lang=ru&format=json`;

      const response = await axios.post(apiUrl, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'Accept': 'application/json',
          'Authorization': 'Bearer ' + localStorage.getItem('token')
        }
      });

      return response.data;
    } catch (error) {
      console.error('Error on file loading', error);
    }
  },

  //Get achievement tasks
  getAchievementTasks({ commit, dispatch, state }, period) {
    return new Promise((resolve, reject) => {
      axios({
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          Authorization: 'Bearer ' + localStorage.getItem('token'),
        },
        method: 'GET',
        url: `${env.api_url}achievements_tasks/?regular_type=${period}`,
        params: {
          lang: localStorage.getItem('language'),
        },
      })
        .then((response) => {
          if (response && typeof response.data.success !== 'undefined') {
            let content = response.data.data
            commit('SET_ACHIEVEMENT_TASKS', { content, period })
            resolve(response);
          }
        })
        .catch((error) => {
          commit('SET_NOTIFICATION_ALERT', {
              text: 'Achievement tasks not found',
              isActive: true,
            });
          reject(error);
        });
    });
  },

  submitTaskAnswer({ commit, dispatch, state }, data) {
    
    return new Promise((resolve, reject) => {

      const headers = {
        Accept: 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('token'),
      };

      if (!(data instanceof FormData)) {
        headers['Content-Type'] = 'application/json';
      }

      axios({
        headers,
        method: 'POST',
        url: `${env.api_url}student_answers/`,
        data: data,
      })
        .then((response) => {
          if (response && typeof response.data.success !== 'undefined') {
            resolve(response);
          }
        })
        .catch((error) => {
          let errorMessage = '';

          if (error.response) {
            errorMessage = error.response.data.data.error_description[0];
          }

          commit('SET_NOTIFICATION_ALERT', {
            text: errorMessage,
            isActive: true,
          });

          reject(error);
        });
    });
  },
  
};

const getters = {
  loggedIn: (state) => state.loggedIn,
  loggedInHash: (state) => state.loggedInHash,
  users: (state) => state.users,
  dashboard: (state) => state.dashboard,
  teachers: (state) => state.teachers,
  students: (state) => state.students,
  userData: (state) => state.userData,
  ckeditorModal: (state) => state.ckeditorModal,
  isStudent: (state) =>
    (state.userData && state.userData.role === 'student') ||
    (state.userData && state.userData.role === 'student/billing'),
  showPreloader: (state) => state.showPreloader,
  questionModalContent: (state) => state.questionModalContent,
  manifest: (state) => state.manifest,
  isBlocked: (state, getters) => {
    if (!getters.isStudent) return false;

    const blockList = state.userData?.popups?.blocking || [];
    
    return blockList.length !== 0;
  },
  blockedCoursesIds: (state, getters) => {
    if (!getters.isStudent) return [];

    const blockCoursesIds = state.userData?.popups?.blocked_courses || [];

    return blockCoursesIds;
  },
  achievementTasks: (state) => state.achievementTasks,
};

export default {
  state,
  mutations,
  actions,
  getters,
};
